module.exports = __webpack_public_path__ + "img/icon7.19c77bde.png";